// import { Navigate } from 'react-router-dom';
import LoginForm from "../pages/login";
import Test from "../pages/test";

const routes = [
    { path : '/login', element : <LoginForm/>},
    { path : '/test', element: <Test/>}
];

export default routes;